const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

const STORAGE_KEY = 'signup_utms';

/**
 * Reads UTM query params from the current URL and persists them
 * in sessionStorage so they survive navigation within the app.
 * Should be called once on app startup (mirrors capturePromoterCode).
 */
export function captureUtmParams(): void {
  const params = new URLSearchParams(window.location.search);
  const utms: UtmParams = {};
  for (const key of UTM_KEYS) {
    const val = params.get(key);
    if (val) utms[key] = val;
  }
  if (Object.keys(utms).length > 0) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
  }
}

export function getStoredUtmParams(): UtmParams {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}
